import { ArrowDownOutlined, ArrowUpOutlined } from '@ant-design/icons';
import styles from './comparison-value.module.scss';
import type { IComparisonValueProps } from './types';

export const ComparisonValue = (props: IComparisonValueProps) => {
  const { value, diff, suffix = '', invertDiff = false } = props;

  const isInverted = invertDiff ? diff < 0 : diff > 0;

  return (
    <div className={styles.comparison}>
      <span className={styles.comparisonValue}>
        {value}
        {suffix}
      </span>
      <span className={isInverted ? styles.positive : styles.negative}>
        {diff > 0 ? <ArrowUpOutlined /> : <ArrowDownOutlined />}
        {Math.abs(diff)}
        {suffix}
      </span>
    </div>
  );
};
